
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/originals/[postId]",
      function () {
        return require("private-next-pages/originals/[postId].tsx");
      }
    ]);
  